import React from 'react'
import './footer2.css'
import footer1 from '../../assets/images/OLDMUTUALTEXT.svg'

function Footer2() {
  return (
    <div className='footer-om'>
                <div className='om-ribbon-bottom'>
                  OLD<span style={{fontWeight:'600'}}>MUTUAL</span>
                </div>
                <div className='footerParent'>
                    
                    <p style={{color: "#ffff", marginLeft: '4%'}} >Copyright Old Mutual Limited {new Date().getFullYear()}</p>
                    <p style={{marginLeft: '10px', marginRight: '10px', color: 'white'}}>|</p>
                    <p ><a style={{color: '#ffff'}} href="https://www.oldmutual.co.zw/about-us/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a></p>
                    <p style={{marginLeft: '10px', marginRight: '10px', color: 'white'}}>|</p>
                    <p ><a style={{color: '#ffff'}} href="https://www.oldmutual.co.zw/about-us" target="_blank" rel="noreferrer">About Us</a></p>
                </div>
            </div>
  )
}

export default Footer2
